import type { HubGeneral } from '~/clc/features/theming/constants';
import type { SectionEditorSettings, SettingsComponentProps } from '~/clc/features/theming/types';
import { CLCHubSectionTypes } from '~/clc/features/theming/constants';
import { SettingsSidebarSubSection } from '../../ThemingEditorPage';
import { ColorSettings } from './ColorSettings';

interface HubColorSettingsProps extends SettingsComponentProps {
  sectionThemeSettings: HubGeneral['colors'];
}

export const HubColorSettings = ({ sectionThemeSettings, onChange }: HubColorSettingsProps) => (
  <SettingsSidebarSubSection>
    <ColorSettings
      onChange={(k: string, v: string) => onChange({ colors: { [k]: v } })}
      isLockable={false}
      colorOptions={sectionThemeSettings}
    />
  </SettingsSidebarSubSection>
);

export const ColorSectionEditorSettings: SectionEditorSettings = {
  type: CLCHubSectionTypes.COLORS,
  schemaKey: 'colors',
  name: 'Color',
  iconName: 'colors:regular',
  settings: HubColorSettings,
};
